import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Card, Button, Form, Input, Modal } from 'antd';
import { getTenants, addTenant } from '../../actions';
import PageHeaderLayout from '../../layouts/PageHeaderLayout';
import StandardTable from '../../components/StandardTable';
import './Tenant.less';

const FormItem = Form.Item;

/**
 * Modal for adding tenant.
 */
const AddTenantForm = Form.create()((props) => {
  const {
    form, modalVisible, handleModalVisible, handleSubmit,
  } = props;

  const handleOk = () => {
    form.validateFields((err, fieldsValue) => {
      if (err) return;
      handleSubmit(fieldsValue);
      form.resetFields();
      handleModalVisible(false);
    });
  };

  const handleCancel = () => {
    form.resetFields();
    handleModalVisible(false);
  };

  return (
    <Modal
      title="Add New Tenant"
      visible={modalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Form>
        <FormItem labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} label="Name">
          {form.getFieldDecorator('name', {
            rules: [{
              required: true,
              message: 'Please input the tenant name',
            }],
          })(<Input />)}
        </FormItem>
        <FormItem labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} label="Authorization Type">
          {form.getFieldDecorator('authType', {
            rules: [{
              required: true,
              message: 'Please input the authorization type',
            }],
          })(<Input />)}
        </FormItem>
        <FormItem labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} label="Workspace">
          {form.getFieldDecorator('workspace', {
            rules: [{
              required: true,
              message: 'Please input the workspace',
            }],
          })(<Input />)}
        </FormItem>
      </Form>
    </Modal>
  );
});

class Tenants extends PureComponent {
  state = {
    modalVisible: false,
  };

  componentDidMount() {
    this.props.getTenants();
  }

  handleModalVisible = (flag) => {
    this.setState({ modalVisible: flag });
  };

  render() {
    const { modalVisible } = this.state;
    const { match: { path }, tenants, isFetching, addTenant } = this.props;
    
    const columns = [{
      title: 'Name',
      dataIndex: 'name',
      render: (text, record) => (
        <Link to={`/tenant/${record.key}`}>{text}</Link>
      ),
    }, {
      title: 'Workspace',
      dataIndex: 'workspace',
    }, {
      title: 'Authorization Type',
      dataIndex: 'authType',
    }];
    const data = tenants ? tenants.map(tenant => ({ key: tenant.id, ...tenant })) : [];

    return (
      <PageHeaderLayout title="Tenants" description="Manage tenants" className="tenants" path={path}>
        <Card bordered={false}>
          <div className="operator">
            <Button className="btn-add" icon="plus" type="primary" onClick={() => { this.handleModalVisible(true); }} >Add</Button>
          </div>
          <StandardTable columns={columns} data={data} loading={isFetching} />
        </Card>
        <AddTenantForm
          modalVisible={modalVisible}
          handleSubmit={addTenant}
          handleModalVisible={this.handleModalVisible}
        />
      </PageHeaderLayout>
    );
  }
}

function mapStateToProps({ tenant }){
  return {
    tenants: tenant.tenants,
    isFetching: tenant.isFetching,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getTenants, addTenant,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Tenants);



// WEBPACK FOOTER //
// ./src/routes/Tenant/Tenants.js